// extracted by mini-css-extract-plugin
module.exports = {"action":"action--UY3MP5xZ","setting":"setting--E4nQhU5d","account":"account--me_8NVLR","avatar":"avatar--ljlT_udC","menu":"menu--TkgdG8nK","jump":"jump--BKu41QPI"};